export const highlighter = {
	selector: {
		link: '.js-dir-rights',
	},
	attribute: {
		url: 'data-url',
	},
}
